export const getScenarioOptions = (labels, t) => {
  return Object.entries(labels).map(([value, label]) => ({ value, label: t(label) }))
}
